module.exports = __webpack_public_path__ + "img/01_full.39f6bd6b.jpg";